export enum FilterType {
    DayVenue = "Day",
    Venue = "Venue",
    DataField = "DataField",
    DayDataField = "DayDataField",
    Summary = "Summary",
    VenueRunSheet = "VenueRunSheet",
}

export interface ScheduleFilterByDay {
    type: FilterType.DayVenue;
    day: number;
    venueIds: string[];
}

export interface ScheduleFilterByVenue {
    type: FilterType.Venue;
    venueId: string;
}

export interface ScheduleFilterByDataField {
    type: FilterType.DataField;
    dataFieldId: string;
    dataFieldListItemId: string;
}

export interface ScheduleFilterBySummary {
    type: FilterType.Summary;
    venueIds: string[];
}

export type ScheduleFilter = ScheduleFilterByDay | ScheduleFilterByVenue | ScheduleFilterByDataField | ScheduleFilterBySummary;
